// extracted by mini-css-extract-plugin
export default {"root":"_to6dnJA0Cpd1zUNMlWC","days":"_Ls2DyYUU9PSgPDELUlg","weekdays":"s53XrOfr1Ej8PEABR0ss","placeHolderShimmer":"QEqTT0ZkLMl1IXG8irXJ"};